import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../constants";
import { useChatSocket } from "./ChatSocketProvider";

const tokenHeader = () => {
  const t = localStorage.getItem("accessToken") || localStorage.getItem("token");
  return { Authorization: `Bearer ${t}` };
};

export function useUnreadTotal() {
  const { socket } = useChatSocket();
  const [unreadTotal, setUnreadTotal] = useState(0);
  const unreadMapRef = useRef<Record<number, number>>({});

  const recalc = () => {
    const sum = Object.values(unreadMapRef.current).reduce(
      (a, b) => a + (Number(b) || 0),
      0
    );
    setUnreadTotal(sum);
  };

  const fetchSnapshot = async () => {
    try {
      const { data } = await axios.get<Record<number, number>>(
        `${baseUrl}/chat/unread-counts`,
        { headers: tokenHeader() }
      );
      unreadMapRef.current = Object.fromEntries(
        Object.entries(data || {}).map(([k, v]) => [Number(k), Number(v || 0)])
      );
      recalc();
    } catch (e) {
      // snapshot failing is fine; socket events will populate
    }
  };

  useEffect(() => {
    fetchSnapshot();

    console.log("[useUnreadTotal] socket", socket?.id, "connected?", socket?.connected);
    if (!socket) return;

    const onConnect = () => socket.emit("unread.request");
    const onUnreadSync = (map: Record<number, number>) => {
      unreadMapRef.current = Object.fromEntries(
        Object.entries(map || {}).map(([k, v]) => [Number(k), Number(v || 0)])
      );
      recalc();
    };
    const onUnread = (p: { channelId: number; unread: number }) => {
      unreadMapRef.current = {
        ...unreadMapRef.current,
        [Number(p.channelId)]: Number(p.unread || 0),
      };
      recalc();
    };

    socket.on("connect", onConnect);
    socket.on("unread.sync", onUnreadSync);
    socket.on("channel.unread", onUnread);

    if (socket.connected) onConnect();

    return () => {
      socket.off("connect", onConnect);
      socket.off("unread.sync", onUnreadSync);
      socket.off("channel.unread", onUnread);
    };
  }, [socket]);

  return { unreadTotal };
}
